module.exports = __webpack_public_path__ + "static/nathalie-e12c6dfde8ebe2ef847a1ee5e7fba592.png";